import React, { useState } from 'react';
import CheckboxMultiple from '../../atoms/CheckBoxMultiple';
import { useRouter } from '../../../hooks/useCustomRouter';
import { cleanedQueryAccessories } from '../../../helpers/utils/cleanedQueryAccessories';
import { IFilterOptions } from '../../../interface/accessories.interface';
import eventClickCouponServiceList from '../../../helpers/emarsys/coupon-service/eventClickCouponServiceList';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../store';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';
import {
  BUTTON_NAME_SERVICE_COUPON,
  SECTION_NAME_SERVICE_COUPON,
} from '../../../constants/emarsys/service-coupon';
import eventClickPackageServiceList from '../../../helpers/emarsys/package-service/eventClickPackageServiceList';
import {
  BUTTON_NAME_SERVICE_PACKAGE,
  SECTION_NAME_SERVICE_PACKAGE,
} from '../../../constants/emarsys/service-package';

export interface FilterCarModelProps {
  carModelList: IFilterOptions['values'];
  typeID: string;
  setTrigger: () => void;
  isPLPCategory?: boolean;
  impressionData?: {
    title?: string;
    carModels: string[];
    breadcrumbItems: IBreadcrumbs[];
    customerNo?: string;
    carCategory?: string;
    filterValue?: {
      search?: string;
      special_offer?: string;
      car_model?: string;
      order_by?: string;
    };
    sectionName: string;
  };
  feature?: string;
}

export default function FilterCarModel({
  carModelList,
  typeID,
  setTrigger,
  isPLPCategory = false,
  impressionData,
  feature,
}: FilterCarModelProps) {
  const router = useRouter();
  const [dataCheckbox, setDataCheckbox] = useState([]);
  const dispatch = useDispatch();
  const { userData } = useSelector((state: IRootState) => state.auth);

  const handleFilterChange = (e) => {
    const { value, checked } = e.target;
    let cleanedQuery = value;
    let sort = '';
    const existingQueryParams: any = router.query;

    if (existingQueryParams?.q) {
      delete existingQueryParams.q;
    }

    const newUrl = new URLSearchParams(existingQueryParams || '').toString();

    const paramsForPLPAcc =
      typeID === 'accessories'
        ? existingQueryParams?.carModel
          ? `/${existingQueryParams.carModel}`
          : newUrl
        : '';

    if (cleanedQuery.includes('baseServicesBodyType')) {
      cleanedQuery = cleanedQuery
        .split('%3A')
        .filter(
          (param, index, array) =>
            !(param.startsWith('baseServicesBodyType') && array[index + 1]) &&
            !(array[index - 1] && array[index - 1].startsWith('baseServicesBodyType'))
        )
        .join('%3A');
    }

    if (typeID === 'accessories') {
      if (existingQueryParams?.sort) {
        delete existingQueryParams.carModel;
      }

      sort = existingQueryParams?.sort
        ? `&${new URLSearchParams(existingQueryParams || '').toString()}`
        : '';

      if (isPLPCategory) {
        cleanedQuery = cleanedQueryAccessories(cleanedQuery, 'accessoriesCategory');
      } else {
        cleanedQuery = cleanedQueryAccessories(cleanedQuery, 'carModel');
      }
    }

    const carModelListTemp = carModelList
      ?.filter((item) => item?.selected)
      ?.map((item) => {
        return item.name;
      });
    const valueCode = carModelList?.find((item) => {
      const val = item?.query?.url.replace(/%3AbodyType%3A\w+/gi, '');
      return (
        val.replace(
          feature === 'PACKAGE_SERVICE_LIST' ? '/c/BASESERVICE' : '/c/BASECOUPONSERVICES',
          ''
        ) === value
      );
    })?.name;

    if (feature === 'COUPON_SERVICE_LIST') {
      eventClickCouponServiceList(
        dispatch,
        impressionData?.carCategory || '',
        impressionData?.title || '',
        impressionData?.breadcrumbItems,
        userData?.customerNo || '',
        SECTION_NAME_SERVICE_COUPON.FILTER,
        BUTTON_NAME_SERVICE_COUPON.MODEL_MOBIL,
        {
          ...impressionData.filterValue,
          car_model: checked
            ? [...carModelListTemp, valueCode].join(',')
            : carModelListTemp.filter((e) => e !== valueCode).join(','),
        }
      );
    }

    if (feature === 'PACKAGE_SERVICE_LIST') {
      eventClickPackageServiceList(
        dispatch,
        impressionData?.carCategory,
        impressionData?.title,
        impressionData?.breadcrumbItems,
        userData?.customerNo,
        SECTION_NAME_SERVICE_PACKAGE.FILTER,
        BUTTON_NAME_SERVICE_PACKAGE.MODEL_MOBIL,
        [],
        {
          ...impressionData.filterValue,
          car_model: checked
            ? [...carModelListTemp, valueCode].join(',')
            : carModelListTemp.filter((e) => e !== valueCode).join(','),
        }
      );
    }

    if (newUrl === '') {
      router.push(
        typeID === 'accessories'
          ? `${process.env.NEXT_PUBLIC_URL}/c/aksesoris${paramsForPLPAcc}${cleanedQuery}`
          : cleanedQuery
      );
    } else {
      router.push(
        typeID === 'accessories'
          ? `${process.env.NEXT_PUBLIC_URL}/c/aksesoris${paramsForPLPAcc}${cleanedQuery}${sort}`
          : cleanedQuery + `&` + newUrl
      );
    }

    if (checked) {
      setDataCheckbox([...dataCheckbox, value]);
    } else {
      setDataCheckbox(dataCheckbox.filter((e) => e !== value));
    }
  };

  return (
    <div>
      {carModelList?.map((item, _i) => {
        return (
          <CheckboxMultiple
            key={_i}
            label={item?.name}
            image={item?.url}
            value={
              typeID === 'package'
                ? item?.query?.url?.replace('/c/BASESERVICE', '')
                : ['accessories', 'accessoriesWithAllFilter'].includes(typeID)
                  ? item?.query?.url?.replace('/c/aksesoris', '')
                  : item?.query?.url?.replace('/c/BASECOUPONSERVICES', '')
            }
            onChange={handleFilterChange}
            checked={item?.selected}
            setTrigger={setTrigger}
          />
        );
      })}
    </div>
  );
}
